import * as React from 'react';
import styles from './assets/dataSheet.module.scss';
import classNames from 'classnames';
export interface Props {
    text: string;
}

const DataSheetLabel: React.FunctionComponent<Props> = ({ text }: Props) => {
    let label = text;
    const typesDataS: AnyStringObject = {
        Waiting: '#FD0013',
        OK: '#0B8080',
        'Not required': '#0084FA',
        All: 'transparent',
    };

    let backC = '';
    if (typesDataS[text]) {
        backC = typesDataS[text];
    } else {
        if (text.length > 5) {
            backC = '#0B8080';
            label = 'OK';
        } else {
            backC = 'transparent';
        }
    }

    return (
        <div className={classNames(styles.datasheet)}>
            <span style={{ background: backC }} className={classNames(styles.datasheetText)}>
                {label}
            </span>
        </div>
    );
};

export default DataSheetLabel;
